"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M846.873 1807.059v-338.824h112.715v-112.94H846.873v-112.942h112.715v-112.941H846.873V1016.47h112.715V903.529H846.873V790.59h112.715V677.646H846.873V441.261c65.506-23.379 112.715-85.496 112.715-158.908V112.94h225.883v451.765h451.764v1242.353H846.873zm-564.932 0V112.94h338.824v169.412c0 73.638 47.435 135.755 113.167 159.134v123.219H620.765v112.941h113.167v112.941H620.765V903.53h113.167v112.942H620.765v112.94h113.167v112.942H620.765v112.941h113.167v112.941H620.765v112.941h113.167v225.883h-451.99zM846.647 112.94v169.412c0 31.172-25.412 56.47-56.47 56.47-31.06 0-56.471-25.298-56.471-56.47V112.94h112.941zm451.765 23.379l315.444 315.445h-315.444V136.32zm402.183 242.485L1371.485 49.58C1339.86 18.071 1296.265 0 1251.655 0H169v1920h1581.176V498.522c0-45.176-17.618-87.755-49.58-119.717z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconZipped = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconZipped, _Component);
  function IconZipped() {
    (0, _classCallCheck2.default)(this, IconZipped);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconZipped).apply(this, arguments));
  }
  (0, _createClass2.default)(IconZipped, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconZipped",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconZipped.displayName = "IconZipped";
  return IconZipped;
}(_react.Component);
exports.default = IconZipped;
IconZipped.glyphName = 'zipped';
IconZipped.variant = 'Line';
IconZipped.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);